import type { ClientKind } from '@/kinds/kind'
import { apply, defaults, displayName, initialStatus, validate } from './apply'
import { workspaceSpec, workspaceStatus, type WorkspaceSpec, type WorkspaceStatus } from './schema'
import { WorkspaceForm } from './components'

const Nothing = () => null

export const workspaceKind: ClientKind<WorkspaceSpec, WorkspaceStatus> = {
  name: 'Workspace',
  version: 1,
  spec: workspaceSpec,
  status: workspaceStatus,
  defaults,
  validate,
  initialStatus,
  displayName,
  apply,
  actions: ['archive', 'restore'],
  ListRow: Nothing,
  Detail: Nothing,
  Form: WorkspaceForm,
}

export * from './schema'
export type { WorkspaceResource } from './apply'
